/* eslint-disable react/prop-types */
/*
 * Modal Component
 *
 */
import './Modal.scss';

export default function Modal(props) {
    const {title, className, children} = props;
    return (
        <div id="modal-view" className="media-modal">
            <div id="modal-mask" />
            {title && (
                <div id="modal-window" className={className}>
                    <div>
                        <div id="modal-header">
                            <h1>{title}</h1>
                        </div>
                        <div id="modal-body">{children}</div>
                    </div>
                </div>
            )}
            {!title && (
                <div id="modal-window" className={className}>
                    {children}
                </div>
            )}
        </div>
    );
}
